import axios from 'axios';


export const HTTP = axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? '/api/v1' : 'https://api-import.kpi.com/api/v1'
    //baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:8081/invoice-import/api/v1' : '/invoice-import/api/v1'
});

// Add a response interceptor
HTTP.interceptors.response.use(function (response) {
    // Do something with response data
    console.log("ENV:" + process.env.NODE_ENV);
    if (response) {
        console.log(response);
    }
    return response;
}, function (error) {
    // Do something with response error
    return Promise.reject(error);
});


export const requestToLogin = params => {
    return HTTP.post(`/auth/login`, params).then(res => res.data);
};

export const getCompaniesList = () => {
    setAuthToken();
    return HTTP.get(`/auth/getCompaniesList`).then(res => res.data);
};

export const loginByCompany = params => {
    setAuthToken();
    return HTTP.get(`/auth/loginByCompany/` + params).then(res => res.data);
};


export const uploadFile = (param, conf) => {
    setAuthToken();
    return HTTP.post('/upload_file', param, conf)
};

export const getImportLogs = params => {
    setAuthToken();
    return HTTP.get(`/import_logs`, {params});
};

const setAuthToken = () => {
    if (sessionStorage.getItem('token')) {
        HTTP.defaults.headers.common['Authentication'] = sessionStorage.getItem('token');
        console.log("SessionID: "+sessionStorage.getItem('token'));
    }
}



// WEBPACK FOOTER //
// ./src/api/api.js